/* unplugin-vue-components disabled */import script from "./proto-pagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./proto-pagination.vue?vue&type=script&setup=true&lang=ts"

import "./proto-pagination.vue?vue&type=style&index=0&id=4746d478&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4746d478"]])

export default __exports__